import React from 'react';
import { useZitoneoPreview } from '../../../contexts/ZitoneoContentContext';
import useTranslate from '../../../../../customHooks/useTranslate';

const OverviewSection = () => {
    const { ServiceCategories } = useZitoneoPreview();
    const translate = useTranslate();

    const topCategories = [...ServiceCategories]
        .sort((a, b) => b.ServiceCount - a.ServiceCount)
        .slice(0, 2);

    const topRepeatedServices = Object.values(
        ServiceCategories.flatMap(category => category.Services).reduce(
            (acc, service) => {
                const key = String(service.IdServiceType);

                if (!acc[key]) {
                    acc[key] = {
                        id: key,
                        name: service.ServiceType,
                        count: 0,
                    };
                }

                acc[key].count += 1;
                return acc;
            },
            {} as Record<string, { id: string; name: string; count: number }>
        )
    )
        .sort((a, b) => b.count - a.count)
        .slice(0, 2);

    return (
        <section className='zitoneo-web-preview__overview'>
            <ul className='overview__list'>
                {topCategories.map(category => (
                    <li className='overview__item' key={category.Id}>
                        <span className='overview__item-title__count'>
                            {category.ServiceCount}
                        </span>
                        <div className='overview__item-title'>
                            <h5 className='overview__item-label'>
                                {category.Name}
                            </h5>
                            <p className='overview__item-sublabel'>
                                {translate('category')}
                            </p>
                        </div>
                    </li>
                ))}
                {topRepeatedServices.map(service => (
                    <li className='overview__item' key={service.id}>
                        <span className='overview__item-title__count'>
                            {service.count}
                        </span>
                        <div className='overview__item-title'>
                            <h5 className='overview__item-label'>
                                {service.name}
                            </h5>
                            <p className='overview__item-sublabel'>
                                {translate('services')}
                            </p>
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default OverviewSection;
